import { AdvisoryResponse } from "../models/crop";

export function extractCropAndSowingDate(advisory: AdvisoryResponse | null) {

    let cropId = null;
    let cropName = null;
    let cropImage = null;
    let sowingDate = null;

    advisory?.data_points.forEach(dp => {
        if (dp.query_type === 'CROP' && typeof dp.value === 'object') {
            cropId = dp.value.id;
            cropName = dp.value.name;
            cropImage = dp.value.image;
        }

        if (dp.query_type === 'SOWING_DATE' && typeof dp.value === 'string') {
            sowingDate = dp.value;
        }
    });

    return { cropId, cropName, cropImage, sowingDate };
}


declare global {
    interface Window {
        AndroidBridge?: {
            onBackIconPressed: () => void
        }
    }
}

export const sendBackEventToAndroid = (window: Window) => {
    if (window && window.AndroidBridge) {
        window.AndroidBridge.onBackIconPressed()
    }
}